export enum CustomErrorType {
  failedToFetch = 'Failed to fetch',
  requestAborted = 'Request Aborted',
  requestTimeout = 'Request Timeout',
  unknown = 'Unknown',
}

export type CustomErrorOptions = {
  error?: Error;
  status?: number;
  url?: string;
  details?: string;
};

export default class CustomError extends Error {
  type: CustomErrorType;
  status?: number;
  /** The raw TypeError/DOMException thrown by fetch. */
  originalError?: Error;
  /** The full request URL that failed. */
  requestUrl?: string;
  /** Additional context about the failure. */
  details?: string;

  constructor(message: string, params: CustomErrorOptions = {}) {
    super(message);

    const { error, status, url, details } = params;

    this.details = details;
    this.status = status;
    this.originalError = error;
    this.requestUrl = url;

    // Detect error type; handles cross-browser fetch error messages:
    //   Chrome/Edge: "Failed to fetch"
    //   Safari:      "Load failed"
    //   Firefox:     "NetworkError when attempting to fetch resource."
    if (message.includes('request timeout')) {
      this.type = CustomErrorType.requestTimeout;
    } else if (error?.name === 'AbortError') {
      this.type = CustomErrorType.requestAborted;
    } else if (
      error &&
      (error.message === 'Failed to fetch' ||
        error.message === 'Load failed' ||
        error.message.includes('NetworkError'))
    ) {
      this.type = CustomErrorType.failedToFetch;
    } else {
      this.type = CustomErrorType.unknown;
    }
  }
}
